export const navLinks = [
  { label: 'Home', path: '/' },
  { label: 'Who We Are', path: '/who-we-are' },
  { label: 'Framework', path: '/framework' },
  { label: 'ERM Index', path: '/erm-efficiency-index' },
  { label: 'Capabilities', path: '/capabilities' },
  { label: 'Technology', path: '/technology' },
  { label: 'Industries', path: '/industries' },
  { label: 'Insights', path: '/insights' },
  { label: 'Leadership', path: '/leadership' },
  { label: 'Contact', path: '/contact' },
];

export const footerLinks = [
  { label: 'Home', to: '/' },
  { label: 'Who We Are', to: '/who-we-are' },
  { label: 'Framework', to: '/framework' },
  { label: 'ERM Index', to: '/erm-efficiency-index' },
  { label: 'Capabilities', to: '/capabilities' },
  { label: 'Technology', to: '/technology' },
  { label: 'Industries', to: '/industries' },
  { label: 'Insights', to: '/insights' },
  { label: 'Leadership', to: '/leadership' },
  { label: 'Contact', to: '/contact' },
];
